<template>
  <div>
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <!-- <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.spuCode')" prop="spuCode">
            <BjInput v-model="queryParams.spuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.spuName')" prop="spuName">
            <BjInput v-model="queryParams.spuName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col> -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.skuName')" prop="skuName">
            <BjInput v-model="queryParams.skuName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.skuName')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.skuCode')" prop="skuCode">
            <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.skuCode')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.categoryName')" prop="categoryIdList">
            <BjGoodsTypeTreeSelect v-model="queryParams.categoryIdList" :placeholder="$t('goodsPage.categoryName')" multiple />
          </el-form-item>
        </el-col>
        <el-col v-if="setFlag != 'draft'" :span="colSpan">
          <el-form-item :label="$t('table.statusText')">
            <BjSelectLov v-model="tempStatus" :option-list="GOODS_SKU_STATUS_NORMAL" :placeholder="$t('table.statusText')" :collapse-tags="tempStatus && tempStatus.length > 2" multiple />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.page.ExpirationStatus')" prop="expireStatus">
            <BjSelectLov v-model="queryParams.expireStatus" :option-list="STATUS_YES_NUM" :placeholder="$t('goodsSku.page.ExpirationStatus')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col v-if="setFlag == GOODS_COMBO_TYPES.ORDINARY">
          <!-- <el-button v-permission:BusinessGoodsSkuOrdinary_Delete type="primary" :disabled="tableOperationProp.notSelected" class="delete-btn" @click="onDeleteSelected">{{ $t('delText') }}</el-button> -->
          <!-- <el-button v-permission:BusinessGoodsSkuOrdinary_DownloadTemplate type="primary" disabled @click="onDownload">{{ $t('downloadTemplateText') }}</el-button> -->
          <el-button v-permission:BusinessGoodsSkuOrdinary_ImportData type="primary" @click="onCreate">{{ $t('ExcelConfig.Title') }}</el-button>
          <el-button v-show="queryParams.setFlag == GOODS_COMBO_TYPES.ORDINARY" v-permission:BusinessGoodsSkuOrdinaryAdd type="primary" class="main-btn" @click="onAdd">{{ $t('goodsSku.page.commonSKU') }}</el-button>
          <!-- 推送SKU按钮 -->
          <el-button v-show="queryParams.setFlag == GOODS_COMBO_TYPES.ORDINARY" v-permission:BusinessGoodsSkuOrdinaryAdd :disabled="tableOperationProp.notSelected" type="primary" @click="pushStore">SKU推送</el-button>
          <el-button v-permission:BusinessGoodsSkuOrdinary_Audit type="primary" :disabled="tableOperationProp.notSelected" @click="onAudit()">{{ $t('submitText') }}</el-button>
          <!-- <el-button v-permission:BusinessGoodsSkuOrdinary_SyncThird type="primary" :disabled="tableOperationProp.notSelected" @click="onSyncThird()">{{ $t('goodsSku.page.threeParties') }}</el-button> -->
        </el-col>
        <el-col v-if="setFlag == GOODS_COMBO_TYPES.PACKAGE">
          <!-- <el-button v-permission:BusinessGoodsSkuPackage_Delete type="primary" :disabled="tableOperationProp.notSelected" class="delete-btn" @click="onDeleteSelected">{{ $t('delText') }}</el-button> -->
<!--          <el-button v-permission:BusinessGoodsSkuPackage_DownloadTemplate type="primary" disabled @click="onDownload">{{ $t('downloadTemplateText') }}</el-button>-->
<!--          <el-button v-permission:BusinessGoodsSkuPackage_ImportData type="primary" disabled @click="onLead">{{ $t('importDataText') }}</el-button>-->
          <el-button v-show="queryParams.setFlag == GOODS_COMBO_TYPES.PACKAGE" v-permission:BusinessGoodsSkuPackageAdd type="primary" class="main-btn" @click="onAdd">{{ $t('goodsSku.page.packageSKU') }}</el-button>
          <el-button v-permission:BusinessGoodsSkuPackage_Audit type="primary" :disabled="tableOperationProp.notSelected" @click="onAudit()">{{ $t('submitText') }}</el-button>
          <el-button type="primary" @click="onExport">{{ $t('exportText') }}</el-button>
          <!-- <el-button v-permission:BusinessGoodsSkuPackage_SyncThird type="primary" :disabled="tableOperationProp.notSelected" @click="onSyncThird('Package')">{{ $t('goodsSku.page.threeParties') }}</el-button> -->
        </el-col>
        <el-col v-if="setFlag == 'draft'">
          <el-button v-permission:BusinessGoodsSkuDraft_Audit type="primary" class="main-btn" :disabled="tableOperationProp.notSelected" @click="onAudit()">{{ $t('submitText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <!-- 非草稿 才展示状态列 -->
          <el-table-column v-if="
              (col.prop !== 'bjTableAction' && col.prop !== 'status') ||
                (col.prop === 'status' && setFlag !== 'draft')
            " :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <div v-else-if="col.prop === 'materialMainImages'" class="flex flex-spacebetween">
                <BjViewUrl :url="(scope.row[col.prop] || [])[0]" height="80px" preview />
              </div>
              <template v-else-if="col.prop === 'skuName'">
                <span v-if="setFlag == GOODS_COMBO_TYPES.ORDINARY" class="link" @click="showSku(scope.row)">
                  {{ scope.row[col.prop] }}</span>
                <span v-else>
                  <el-tag v-if="setFlag == 'draft' && scope.row.setFlag == 1">{{ $t('goodsSku.page.Set') }}</el-tag>
                  {{ scope.row[col.prop] }}</span>
              </template>
              <span v-else-if="col.prop === 'licenseExpireDate' && setFlag == GOODS_COMBO_TYPES.ORDINARY" :style="scope.row.licenseExpireDateStatus === 2 ? 'color:red' : scope.row.licenseExpireDateStatus === 1 ? 'color:#082dc3' : ''">{{ scope.row[col.prop] }}</span>
              <el-tag v-else-if="col.prop === 'status'">{{ $t(GOODS_SKU_STATUS.bjGet(scope.row[col.prop])) }}
              </el-tag>
              <!-- 价格 显示 -->
              <span v-else-if="col.prop.toLocaleLowerCase().includes('price')">{{ $number2money(scope.row[col.prop]) }}</span>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button v-permission="
                  props.row.setFlag == GOODS_COMBO_TYPES.ORDINARY
                    ? 'BusinessGoodsSkuOrdinaryView'
                    : 'BusinessGoodsSkuPackageView'
                " type="text" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
              <el-button v-permission="
                  props.row.setFlag == GOODS_COMBO_TYPES.ORDINARY
                    ? 'BusinessGoodsSkuOrdinaryEdit'
                    : 'BusinessGoodsSkuPackageEdit'
                " :disabled="!CAN_EDIT_STATUS.includes(Number(props.row.status))" type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
              <el-button v-if="setFlag == 'draft'" :disabled="!CAN_DELETE_STATUS.includes(Number(props.row.status))" type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <SkuRowData ref="SkuRowData" />
    <!-- 导入弹窗 -->
    <ExcelImportDialog ref="ExcelImport" @submit="handleQuery" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { goodsApi, thirdApi } from '@/api';
import {
  GOODS_SKU_STATUS_NORMAL,
  GOODS_SKU_STATUS,
  GOODS_COMBO_TYPES,
  STATUS_YES_NUM
} from '@/utils/constants';
import papa from 'papaparse';
import SkuRowData from './SkuRowData.vue';
import ExcelImportDialog from './ExcelImportDialog.vue';
/**
 *

                  创建 ——————————————————————————-
                    |                            |
                    |                            |
                    |<———————— ————              |
                    |             |              |
                    |保存          |          提交|
                    ↓             |              |
    ————————————> 0草稿————>编辑———|              |
    |               |                            |
    | 保存          |                            |
    |               | 提交                       |
    |    提交       |                            |
    |————————————>  |                            |
    |               |                            |
    |               ↓                            ↓
1 被驳回 <————————2审核中 <—————————————————————————
           N        |                            ↑
                    |                        提交|
                    | Y                          |
                    |                            |
                    ↓                            |
                  3已生效<———————————————————————
                    |                            |
                    |                            |
                    |编辑——提交                   |
                    |                            |
                    ↓                   Y        |
                4已生效(编辑中，即审核中)——————————
                    | ↑
                  N| |编辑——提交
                    | |
                    ↓ |
                5已生效(被驳回)

 */
// 可以提交审核的状态：0草稿  1被驳回  5已生效(被驳回)
const CAN_SUBMIT_STATUS = [0, 1, 5];
// 可以编辑的状态：0草稿  1被驳回   3已生效   5已生效(被驳回)
const CAN_EDIT_STATUS = [0, 1, 3, 5];
// 可以删除的状态：0草稿  1被驳回  2审核中
const CAN_DELETE_STATUS = [0, 1, 2];
// 可以同步到三方的状态： 3已生效  4已生效-编辑中  5已生效(被驳回)
const CAN_SYNC_STATUS = [3, 4, 5];

let DEFAULT_STATUS, SET_FLAG;
export default {
  name: 'BusinessGoodsSkuPageOrdinaryPackage',
  components: {
    SkuRowData,
    ExcelImportDialog
  },
  mixins: [pageMiXin],
  props: {
    setFlag: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    if (this.setFlag == 'draft') {
      DEFAULT_STATUS = [0];
      SET_FLAG = null;
    } else {
      DEFAULT_STATUS = [...GOODS_SKU_STATUS_NORMAL.map(e => e.value)];
      SET_FLAG = this.setFlag;
    }

    return {
      // colSpan: 8,
      CAN_EDIT_STATUS,
      CAN_SUBMIT_STATUS,
      CAN_DELETE_STATUS,
      GOODS_COMBO_TYPES,
      GOODS_SKU_STATUS,
      GOODS_SKU_STATUS_NORMAL,
      STATUS_YES_NUM,
      queryApi: goodsApi.getSku,
      // 查询参数
      tempStatus: [],
      queryParams: {
        spuCode: null,
        skuCode: null,
        spuName: null,
        categoryIdList: [],
        status: DEFAULT_STATUS,
        setFlag: SET_FLAG,
        expireStatus: null,
      },
      labelsVersion: 11,
      labelList: [
        { label: 'goodsPage.categoryName', prop: 'categoryName', isCheck: true, disabled: false, width: 133 },
        { label: 'goodsPage.skuCode', prop: 'skuCode', isCheck: true, disabled: false },
        { label: 'goodsPage.skuName', prop: 'skuName', isCheck: true, disabled: false, width: 125 },
        { label: 'goodsSku.page.CertificatePeriod', prop: 'licenseExpireDate', isCheck: true, disabled: false, width: 180 },
        { label: 'goodsPage.costPrice', prop: 'costPrice', isCheck: true, disabled: false, width: 90 },
        { label: 'goodsPage.salesPrice', prop: 'salesPrice', isCheck: true, disabled: false, width: 120 },
        { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
      ],
      skuTableRowData: [],
    };
  },
  computed: {
    SCHL_CHANNEL_TYPE() {
      return this.$store.state.values.SCHL_CHANNEL_TYPE || [];
    },
  },
  watch: {
    tempStatus(v, o) {
      if (Array.isArray(v) && v.length) {
        this.queryParams.status = [...v];
      } else {
        this.queryParams.status = [...DEFAULT_STATUS];
      }
    },
  },
  created() {
    if (this.setFlag === GOODS_COMBO_TYPES.PACKAGE) {
      this.labelList.splice(3, 1);
    }
  },
  mounted() {
    this.$store.dispatch('values/getValueList', 'SCHL.CHANNEL_TYPE');
  },
  methods: {
    onCreate() {
      this.$refs.ExcelImport.show();
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.tempStatus = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    // SKU名称点击展示
    showSku(row) {
      const DATA = [
        {
          attributeName: this.$t('goodsPage.skuName'),
          attributeValue: row.skuName,
        },
      ].concat(row.skuAttributeList || []);
      this.$refs.SkuRowData.show(DATA);
    },
    /** 删除 */
    onDelete(row) {
      this.$confirm(
        `${this.$t('toast.youAreDelTipText')}，${this.$t('toast.continueTipText')}`,
        this.$t('toast.hintText'),
        {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        },
      )
        .then(() => {
          const API_DATA = { ids: [row.id] };
          this.deleteApi(API_DATA);
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }

      if (this.selectedRows.some(e => !CAN_DELETE_STATUS.includes(Number(e.status)))) {
        const TEXT = this.$t('chooseText') + ` ${CAN_DELETE_STATUS.map(e => this.$t(GOODS_SKU_STATUS.bjGet(e))).join(
          '/',
        )} ` + this.$t('delText');

        this.$message.warning(TEXT);
        return;
      }
      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          const API_DATA = { ids: ids };
          this.deleteApi(API_DATA);
        })
        .catch(() => {});
    },
    /** 下载模板 */
    onDownload() {
      this.$message.warning('TODO');
    },
    /** 导入数据 */
    onLead() {
      this.$message.warning('TODO');
    },
    /** 导出套餐sku数据 */
    onExport() {
      const fileName = this.$t('goodsAudit.detail.packageSku') + new Date().toLocaleString();
      goodsApi.exportPackageSku(this.queryParams).then(res => {
        if (!res.length) return;
        const csvData = [];
        res.forEach(item => {
          csvData.push({
            'skuCode': item.skuCode,
            'costPrice': item.costPrice
          });
        });
        if (!csvData.length) return;
        const csv = papa.unparse(csvData);
        const data = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const csvURL = window.URL.createObjectURL(data);
        const download = document.createElement('a');
        document.body.appendChild(download);
        download.href = csvURL;
        download.setAttribute('download', fileName);
        download.click();
        document.body.removeChild(download);
      });
    },
    /** 提交审核 */
    onAudit(row) {
      let ids = [];
      if (!row) {
        ids = this.selectedRows.map(e => e.id);
      } else {
        ids.push(row.id);
      }
      if (!this.selectedRows.every(e => CAN_SUBMIT_STATUS.includes(Number(e.status)))) {
        const TEXT = this.$t('chooseText') + ` ${CAN_SUBMIT_STATUS.map(e => this.$t(GOODS_SKU_STATUS.bjGet(e))).join(
          '/',
        )} ` + this.$t('submitText');
        this.$message.warning(TEXT);
        return;
      }
      this.$confirm(this.$t('goodsSku.page.submitTip'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          const API_DATA = { skuIds: ids };

          this.skuBatchSubmitAudit(API_DATA);
        })
        .catch(() => {});
    },
    /** 同步商品信息到第三方平台 */
    onSyncThird(isPackage = false) {
      const myItem = e => {
        const ordinarySep = {
          // 普通SKU独有的，套餐时，不需要传递下面的参数
          categoryCode: e.categoryCode,
          categoryName: e.categoryName,
          height: e.height,
          length: e.length,
          salesPrice: e.salesPrice,
          weight: e.weight,
          width: e.width,
        };
        const normal = {
          // brand: e.brand,  //TODO:没有此字段
          // childList //TODO:没有此字段
          costPrice: e.costPrice,
          goodsRemark: e.goodsRemark,
          skuCode: e.skuCode,
          skuName: e.skuName,
          spuCode: e.spuCode,
          spuName: e.spuName,
        };
        if (!isPackage) {
          return { ...normal, ...ordinarySep };
        } else {
          return normal;
        }
      };
      const skuList = this.selectedRows.map(e => myItem(e));

      if (!this.selectedRows.every(e => CAN_SYNC_STATUS.includes(Number(e.status)))) {
        const TEXT = this.$t('chooseText') + ` ${CAN_SYNC_STATUS.map(e => this.$t(GOODS_SKU_STATUS.bjGet(e))).join(
          '/',
        )} ` + this.$t('goodsSku.page.Sync');
        this.$message.warning(TEXT);
        return;
      }

      const h = this.$createElement;
      const refName = 'BjSelectLovPackageOrdinary20221017';
      const key = 'BjSelectLovKey' + new Date().getTime();
      this.$msgbox({
        title: this.$t('goodsSku.page.SelectChannel'),
        message: h('BjSelectLov', {
          props: { 'option-list': this.SCHL_CHANNEL_TYPE },
          ref: refName,
          key, // 重新渲染
        }),
        showCancelButton: true,
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            // 获取选中值
            const channelCode = this.$refs[refName].id;
            if (channelCode) {
              const API_DATA = isPackage
                ? { channelCode, items: skuList }
                : { channelCode, skuList };
              this.uploadSkuToThirdParty(
                API_DATA,
                () => {
                  done();
                },
                isPackage,
              );
            } else {
              this.$message.warning(this.$t('goodsSku.page.synchronizeProducts'));
            }
          } else {
            done();
          }
        },
      }).then(action => {});
    },
    /** 新建 */
    onAdd() {
      if (this.setFlag == GOODS_COMBO_TYPES.ORDINARY) {
        this.$toPage('BusinessGoodsSkuOrdinaryAdd');
      } else if (this.setFlag == GOODS_COMBO_TYPES.PACKAGE) {
        this.$toPage('BusinessGoodsSkuPackageAdd');
      } else {
        this.$toPage('BusinessGoodsSkuOrdinaryAdd');
      }
    },

    // 推送SKU按钮
    pushStore() {
      if (this.selectedRows.some(e => (Number(e.syncFrom) != 0))) {
        this.$message.warning(this.$t('goodsSku.page.SKU'));
        return;
      }
      if (this.selectedRows.some(e => (Number(e.pushFlag) != 0))) {
        this.$message.warning(this.$t('goodsSku.page.SKUNO'));
        return;
      }
      const ids = this.selectedRows.map(e => e.id);
      const API_DATA = { ids: ids };
      goodsApi.pushSku(API_DATA).then(res => {
        if (res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },

    /** 查看 */
    onView(row) {
      // 通过row 判断 是套餐还是普通SKU
      if (row.setFlag == GOODS_COMBO_TYPES.ORDINARY) {
        this.$toPage('BusinessGoodsSkuOrdinaryView', {
          id: row.id,
          skuCode: row.skuCode,
          type: 'see'
        });
      } else if (row.setFlag == GOODS_COMBO_TYPES.PACKAGE) {
        this.$toPage('BusinessGoodsSkuPackageView', {
          id: row.id,
          skuCode: row.skuCode,
        });
      } else {
        this.$toPage('BusinessGoodsSkuOrdinaryView', {
          id: row.id,
          skuCode: row.skuCode,
        });
      }
    },
    /** 编辑操作 */
    onEdit(row) {
      // 通过row 判断 是套餐还是普通SKU
      if (row.setFlag == GOODS_COMBO_TYPES.ORDINARY) {
        this.$toPage('BusinessGoodsSkuOrdinaryEdit', {
          id: row.id,
          skuCode: row.skuCode,
          setFlag: this.setFlag,
        });
      } else if (row.setFlag == GOODS_COMBO_TYPES.PACKAGE) {
        this.$toPage('BusinessGoodsSkuPackageEdit', {
          id: row.id,
          skuCode: row.skuCode,
          setFlag: this.setFlag,
        });
      } else {
        this.$toPage('BusinessGoodsSkuOrdinaryEdit', {
          id: row.id,
          skuCode: row.skuCode,
          setFlag: this.setFlag,
        });
      }
    },
    /* 关闭弹窗 */
    handleClose() {
      this.dialogVisible = false;
    },
    skuBatchSubmitAudit(API_DATA) {
      // skuIds
      goodsApi.skuBatchSubmitAudit(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    deleteApi(API_DATA) {
      goodsApi.deleteSku(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    updateSkuStatus(row) {
      goodsApi
        .updateSkuStatus({
          id: row.id,
          showFlag: row.showFlag ? 0 : 1,
        })
        .then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        });
    },
    /**
     *
     * @param {*} API_KEY  uploadSkuToThirdPartyPackage /  uploadSkuToThirdPartyOrdinary
     * @param {*} API_DATA
     * @param {*} callback
     */
    uploadSkuToThirdParty(API_DATA, callback, isPackage = false) {
      const API_KEY = isPackage ? 'uploadSkuToThirdPartyPackage' : 'uploadSkuToThirdPartyOrdinary';
      thirdApi[API_KEY](API_DATA)
        .then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
          }
          callback && callback(res);
        })
        .catch(() => {
          callback && callback();
        });
    },
  },
};
</script>
<style scoped>
::v-deep .el-form-item__content{
  height: 29px!important;
}
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
